// Marquee Component
if (!customElements.get('marquee-component')) {
  class Marquee extends HTMLElement {
    constructor() {
      super();

      this.marqueeItems = this.querySelectorAll('.marquee-item');
      this.marqueeItem = this.marqueeItems[0];
      this.animationSpeed = this.dataset.speed / 3 || .5;
      this.animationDirection = this.dataset.direction || 'left';
      this.stopOnHover = this.dataset.stopOnHover || false;
      this.marqueeAnimation = null;
      this.sumOfItemsWidth = 0;
      this.windowWidth = window.innerWidth;
      if(this.animationDirection == 'left') {
        this.translateX = 0;
      } else {
        this.translateX = 2 * this.marqueeItem.offsetWidth * -1;
      }
    }

    connectedCallback() {
      this.init();

      window.addEventListener('resize', this.debounce(() => {
        this.cloneItem();
      }), 500);
      if (this.stopOnHover === 'true') {
        this.stopOnHoverEvents();
      }
    }

    init() {
      this.cloneItem();
      if(this.animationDirection == 'left') {
        this.animateLeft();
      } else {
        this.animateRight();
      }
    }

    cloneItem() {
      this.windowWidth = window.innerWidth;

      if (this.windowWidth + 2 * this.marqueeItem.offsetWidth > this.sumOfItemsWidth ) {
        let clone = this.marqueeItem.cloneNode(true);
        this.appendChild(clone);
        this.sumOfItemsWidth += this.marqueeItem.offsetWidth
        this.cloneItem();
      }
    }

    animateLeft() {
      this.translateX -= this.animationSpeed;
      this.style.transform = `translateX(${this.translateX}px)`;
      if (this.translateX <= -this.marqueeItem.offsetWidth) {
        this.translateX = 0;
      }
      this.marqueeAnimation = requestAnimationFrame(this.animateLeft.bind(this));
    }

    animateRight() {
      this.translateX += this.animationSpeed;
      this.style.transform = `translateX(${this.translateX}px)`;
      if (this.translateX > 0) {
        this.translateX = 2 * this.marqueeItem.offsetWidth * -1;
      }
      this.marqueeAnimation = requestAnimationFrame(this.animateRight.bind(this));
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.marqueeAnimation);
    }

    stopOnHoverEvents() {
      this.addEventListener('mouseenter', () => {
        cancelAnimationFrame(this.marqueeAnimation);
      });

      this.addEventListener('mouseleave', () => {
        if(this.animationDirection == 'left') {
          this.animateLeft();
        } else {
          this.animateRight();
        }
      });
    }

    debounce(func, wait, immediate) {
      let timeout;
      return function () {
        let context = this,
          args = arguments;
        let later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }

  customElements.define("marquee-component", Marquee);
}